<template>
  <div class="frontCommon">
    <commonBanner :bgImg="bgImg" :search="false"></commonBanner>
    <div class="center-setting">
      <MultipleFilter
        :options="filterOptions"
        @chacked="mutipleChacked"
        @closeTag="mutipleChacked"
      ></MultipleFilter>
      <SimpleFilter
        :keywords="keywords"
        :isRank="false"
        @search="handleSearch"
        @searchValueChange="searchValueChange"
      ></SimpleFilter>
      <div class="talent-body-wrap">
        <div class="spanning-wrap" v-if="loading">
          <a-spin class="spin-item" :spinning="loading" />
        </div>
        <Empty v-else-if="isEmpty"></Empty>
        <TalentList :resultList="resultList" v-else></TalentList>
        <Pagination
          ref="pagination"
          :total="total"
          @change="handlerPaginationChange"
        ></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import commonBanner from '@/components/common/banner'
import MultipleFilter from '@/components/MultipleFilter';
import { filterOptions } from '../../config';
import { getTalentDataList } from '@/api/MTalentData.js';
import Empty from '@/components/common/Empty';
import TalentList from '../../component/talentList.vue'
import Pagination from '@/views/IndustryInformation/pages/components/pagination'
import SimpleFilter from '@/components/common/SimpleFilter'
import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      keywords: '', // 检索关键词
      loading: false,
      isEmpty: false,
      resultList: [],
      filterOptions: [], // 多选过滤
      searchParams: {
        industry: '',
        expertsType: '',
      },
      pageParams: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      bgImg: require('@/assets/images/人才智库banner.png'),
      datas: '', //多选按钮值
      searchVal: ''
    };
  },
  components: {
    MultipleFilter,
    Empty,
    TalentList,
    Pagination,
    commonBanner,
    SimpleFilter
  },
  watch: {
    $route: {
      handler(nVal) {
        const { keywords } = nVal.query
        if (keywords && keywords !== '') {  //处理首页搜索
          this.keywords = keywords
          this.handleSearch(keywords)
        } else {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.filterOptions = cloneDeep(filterOptions)
  },
  methods: {
    searchValueChange(value) {
      this.searchVal = value
    },
    // 加载数据
    async loadData() {
      try {
        this.loading = true;
        const { data } = await getTalentDataList({ ...this.searchParams, ...this.pageParams });
        const { rows } = data;
        this.total = data.total
        this.isEmpty = rows.length === 0;
        this.resultList = rows;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 点击选择条件进行过滤
    mutipleChacked(params) {
      const datas = {};
      Object.keys(params).forEach((key) => {
        const data = params[key];
        if (Object.keys(data).length === 0) return;
        const {
          instance: { prop },
          value,
        } = data;
        datas[prop] = value;
      });
      this.datas = datas; //记录多选值
      this.searchParams = { ...datas, name: this.searchVal };
      this.loadData();
    },
    // 分页器参数变化，带动列表的数据变化
    handlerPaginationChange() {
      const paginationRef = this.$refs.pagination
      this.pageParams = {
        pageNum: paginationRef.currentPage || 1,
        pageSize: paginationRef.pageSize || 10,
      }
      this.loadData()
    },
    //simple
    handleSearch(e) {
      this.searchVal = e //记录搜索的值
      const params = { name: e, ...this.datas }
      this.searchParams = params
      // 更新到vuex中
      // this.updateTabValue({ key: 'result', value: e })
      this.loadData()
    },
  },
};
</script>
<style scoped>
.infos-wrap {
  display: inline-block;
}
</style>
